import { normalize } from 'normalizr';
import { pathOr } from 'ramda';

import { schema } from 'store/quotes';

import { notify } from 'utils/reduxUtils';

export const types = {
  BULK_UPDATE_COMPONENTS_ERROR: 'baq/sideNav/BULK_UPDATE_COMPONENTS_ERROR',
  BULK_UPDATE_COMPONENTS_REQUEST: 'baq/sideNav/BULK_UPDATE_COMPONENTS_REQUEST',
  BULK_UPDATE_COMPONENTS_SUCCESS: 'baq/sideNav/BULK_UPDATE_COMPONENTS_SUCCESS',

  COPY_QUOTE_ITEMS_IN_QUOTE_ERROR:
    'baq/sideNav/COPY_QUOTE_ITEMS_IN_QUOTE_ERROR',
  COPY_QUOTE_ITEMS_IN_QUOTE_REQUEST:
    'baq/sideNav/COPY_QUOTE_ITEMS_IN_QUOTE_REQUEST',
  COPY_QUOTE_ITEMS_IN_QUOTE_SUCCESS:
    'baq/sideNav/COPY_QUOTE_ITEMS_IN_QUOTE_SUCCESS',

  DELETE_QUOTE_ITEMS_ERROR: 'baq/sideNav/DELETE_QUOTE_ITEMS_ERROR',
  DELETE_QUOTE_ITEMS_REQUEST: 'baq/sideNav/DELETE_QUOTE_ITEMS_REQUEST',
  DELETE_QUOTE_ITEMS_SUCCESS: 'baq/sideNav/DELETE_QUOTE_ITEMS_SUCCESS',

  MAKE_QUOTE_ITEMS_ASSEMBLIES_ERROR:
    'baq/sideNav/MAKE_QUOTE_ITEMS_ASSEMBLIES_ERROR',
  MAKE_QUOTE_ITEMS_ASSEMBLIES_REQUEST:
    'baq/sideNav/MAKE_QUOTE_ITEMS_ASSEMBLIES_REQUEST',
  MAKE_QUOTE_ITEMS_ASSEMBLIES_SUCCESS:
    'baq/sideNav/MAKE_QUOTE_ITEMS_ASSEMBLIES_SUCCESS',

  MERGE_QUOTE_ITEMS_REQUEST: 'baq/sideNav/MERGE_QUOTE_ITEMS_REQUEST',
  SIDE_NAV_TOGGLE_IS_EXPANDED: 'baq/sideNav/SIDE_NAV_TOGGLE_IS_EXPANDED',
  QUOTE_ITEM_SELECT_DESELECT_ALL: 'baq/sideNav/QUOTE_ITEM_SELECT_DESELECT_ALL',

  QUOTE_ITEM_SELECT_DESELECT_BULK:
    'baq/sideNav/QUOTE_ITEM_SELECT_DESELECT_BULK',
  QUOTE_ITEM_SELECT_MERGE_SELECTION:
    'baq/sideNav/QUOTE_ITEM_SELECT_MERGE_SELECTION',
  QUOTE_ITEM_SELECT_TOGGLE: 'baq/sideNav/QUOTE_ITEM_SELECT_TOGGLE',
  REFRESH_QUOTE_ITEMS_REQUEST: 'quoteItems/REFRESH_QUOTE_ITEMS_REQUEST',
  REFRESH_QUOTE_ITEMS_SUCCESS: 'quoteItems/REFRESH_QUOTE_ITEMS_SUCCESS',
  REFRESH_QUOTE_ITEMS_ERROR: 'quoteItems/REFRESH_QUOTE_ITEMS_ERROR',

  QUOTE_ITEM_FILTER_SEARCH: 'baq/sideNav/QUOTE_ITEM_FILTER_SEARCH',
  QUOTE_ITEM_FILTER_CLEAR: 'baq/sideNav/QUOTE_ITEM_FILTER_CLEAR',
  QUOTE_ITEM_FILTER_SET_FILTERED_IDS:
    'baq/sideNav/QUOTE_ITEM_FILTER_SET_FILTERED_IDS',
  REPLACE_TEMP_ERP_QUOTE_ITEM_REQUEST:
    'quoteItems/REPLACE_TEMP_ERP_QUOTE_ITEM_REQUEST',
  REPLACE_TEMP_ERP_QUOTE_ITEM_SUCCESS:
    'quoteItems/REPLACE_TEMP_ERP_QUOTE_ITEM_SUCCESS',
  REPLACE_TEMP_ERP_QUOTE_ITEM_ERROR:
    'quoteItems/REPLACE_TEMP_ERP_QUOTE_ITEM_ERROR',
  REPLACE_TEMP_CONVERTED_FROM_QUOTE_FILE_QUOTE_ITEM_REQUEST:
    'quoteItems/REPLACE_TEMP_CONVERTED_FROM_SUPPORTING_FILE_QUOTE_ITEM_REQUEST',
  REPLACE_TEMP_CONVERTED_FROM_QUOTE_FILE_QUOTE_ITEM_ERROR:
    'quoteItems/REPLACE_TEMP_CONVERTED_FROM_SUPPORTING_FILE_QUOTE_ITEM_ERROR',
};

export const quoteItemFilter = {
  search: (value) => ({
    type: types.QUOTE_ITEM_FILTER_SEARCH,
    payload: {
      value,
    },
  }),
  clear: () => ({
    type: types.QUOTE_ITEM_FILTER_CLEAR,
  }),
  setFilteredIds: (quoteItemIds) => ({
    type: types.QUOTE_ITEM_FILTER_SET_FILTERED_IDS,
    payload: { quoteItemIds },
  }),
};

export const copyQuoteItemsInQuote = {
  error: notify(
    (error) => ({
      type: types.COPY_QUOTE_ITEMS_IN_QUOTE_ERROR,
      payload: error,
    }),
    'Failed to duplicate quote items',
  ),
  request: ({ quoteItemIds }) => ({
    type: types.COPY_QUOTE_ITEMS_IN_QUOTE_REQUEST,
    payload: { quoteItemIds },
  }),
  success: () => ({
    type: types.COPY_QUOTE_ITEMS_IN_QUOTE_SUCCESS,
  }),
};

export const deleteQuoteItems = {
  error: notify(
    (error) => ({
      type: types.DELETE_QUOTE_ITEMS_ERROR,
      payload: error,
    }),
    "Can't delete quote item(s)",
  ),
  request: ({ quoteItemIds, onSettledCallback }) => ({
    type: types.DELETE_QUOTE_ITEMS_REQUEST,
    payload: { quoteItemIds, onSettledCallback },
  }),
  success: () => ({
    type: types.DELETE_QUOTE_ITEMS_SUCCESS,
  }),
};

export const makeQuoteItemsAssemblies = {
  error: notify(
    ({ error }) => ({
      type: types.MAKE_QUOTE_ITEMS_ASSEMBLIES_ERROR,
      payload: { error },
    }),
    'Failed to make quote item an assembly',
    (action) => pathOr('', ['payload', 'error', 'message'], action), // adding custom get message function
  ),
  request: ({ quoteItemIds }) => ({
    type: types.MAKE_QUOTE_ITEMS_ASSEMBLIES_REQUEST,
    payload: { quoteItemIds },
  }),
  success: () => ({
    type: types.MAKE_QUOTE_ITEMS_ASSEMBLIES_SUCCESS,
  }),
};

export const mergeQuoteItems = {
  request: ({ mergeType, selectedQuoteItems }) => ({
    type: types.MERGE_QUOTE_ITEMS_REQUEST,
    payload: { mergeType, selectedQuoteItems },
  }),
};

export const quoteItemSelect = {
  deselectAll: () => ({
    type: types.QUOTE_ITEM_SELECT_DESELECT_ALL,
  }),
  deselectBulk: ({ lastSelection, quoteItemIds }) => ({
    type: types.QUOTE_ITEM_SELECT_DESELECT_BULK,
    payload: { lastSelection, quoteItemIds },
  }),
  mergeSelection: ({ lastSelection, quoteItemIds }) => ({
    type: types.QUOTE_ITEM_SELECT_MERGE_SELECTION,
    payload: { lastSelection, quoteItemIds },
  }),
  toggle: ({ quoteItemId }) => ({
    type: types.QUOTE_ITEM_SELECT_TOGGLE,
    payload: { quoteItemId },
  }),
};

export const sideNav = {
  toggleExpanded: () => ({
    type: types.SIDE_NAV_TOGGLE_IS_EXPANDED,
  }),
};

export const bulkUpdateRootComponents = {
  request: ({ quoteItemIds }) => ({
    type: types.BULK_UPDATE_COMPONENTS_REQUEST,
    payload: { quoteItemIds },
  }),
  success: notify(
    () => ({
      type: types.BULK_UPDATE_COMPONENTS_SUCCESS,
    }),
    'Updated process, material, and finish',
  ),
  error: notify((error) => ({
    type: types.BULK_UPDATE_COMPONENTS_ERROR,
    payload: error,
  })),
};

export const refreshQuoteItems = {
  request: ({ quoteItemIds }) => ({
    type: types.REFRESH_QUOTE_ITEMS_REQUEST,
    payload: { quoteItemIds },
  }),
  success: notify(
    ({ quoteItems }) => ({
      type: types.REFRESH_QUOTE_ITEMS_SUCCESS,
      payload: normalize(quoteItems, schema.quoteItems),
    }),
    'Pricing successfully refreshed',
  ),
  error: notify(
    (error) => ({
      type: types.REFRESH_QUOTE_ITEMS_ERROR,
      payload: error,
    }),
    'Could not refresh Quote Items',
  ),
};

export const replaceTempErpQuoteItems = {
  error: notify(
    (error) => ({
      type: types.REPLACE_TEMP_ERP_QUOTE_ITEM_ERROR,
      payload: error,
    }),
    'Error updating status',
  ),
  request: ({ successes, failures }) => ({
    type: types.REPLACE_TEMP_ERP_QUOTE_ITEM_REQUEST,
    payload: { successes, failures },
  }),
};

export const replaceTempConvertedFromQuoteFileQuoteItems = {
  error: notify(
    (error) => ({
      type: types.REPLACE_TEMP_CONVERTED_FROM_QUOTE_FILE_QUOTE_ITEM_ERROR,
      payload: error,
    }),
    'Error updating status',
  ),
  request: ({ successes, failures }) => ({
    type: types.REPLACE_TEMP_CONVERTED_FROM_QUOTE_FILE_QUOTE_ITEM_REQUEST,
    payload: { successes, failures },
  }),
};
